var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { P, ViewChild, CustomElement, Watch, Utils, PropertyConverters } from '@pacem/pacem-core';
import { Components as ComponentsMaps, Maps } from '@pacem/pacem-maps';
import { PacemBaseElement } from './types-components';
import { FieldChangeEventName } from './types';
const MIN_LENGTH = 3;
let PacemGeolocateElement = class PacemGeolocateElement extends PacemBaseElement {
    constructor() {
        super(...arguments);
        this._dragendHandler = (e) => {
            this._reverseGeocoder.position = e.detail.position;
        };
    }
    get inputFields() {
        return [];
    }
    toggleReadonlyView(readonly) {
        this._setupSuggest();
        this._setupMapMarker();
    }
    onChange(evt) {
        return new Promise((resolve, _) => {
            if (evt.type === 'success' && evt.target === this._reverseGeocoder) {
                const position = this.#marker.position;
                const sorted = evt.detail.sort((a, b) => {
                    const da = Maps.MapProjection.distanceBetween(a.position, position), db = Maps.MapProjection.distanceBetween(b.position, position);
                    return da < db ? 0 : -1;
                });
                const altitude = sorted[0].position.altitude;
                const value = Utils.extend({}, sorted[0], { position: Utils.extend({ altitude }, position) });
                resolve(this.value = value);
            }
            else if (evt.type === FieldChangeEventName && evt.target === this._suggest) {
                resolve(this.value = this._suggest.value);
            }
            else {
                resolve(this.value);
            }
        });
    }
    fetch(search) {
        if (Maps.LatLng.isLatLng(search)) {
            this.#marker.position =
                this._reverseGeocoder.position = search;
        }
    }
    compareValuePropertyValues(old, any) {
        const pos1 = old?.position ?? Maps.LatLng.Empty, pos2 = any?.position ?? Maps.LatLng.Empty;
        return Maps.LatLng.equals(pos1, pos2);
    }
    acceptValue(val) {
        if (!Utils.isNull(val)) {
            this._datasource.model = [val];
            this._setupMapMarker();
        }
        else {
            this._datasource.model = [];
        }
        this._setupSuggest();
    }
    getViewValue(value) {
        return value?.fullAddress || '';
    }
    convertValueAttributeToProperty(attr) {
        return PropertyConverters.Json.convert(attr, this);
    }
    #marker;
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._setup();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'adapter':
                    this._setupAdapters(val);
                    break;
                case 'map':
                    if (old) {
                        this._detachMarker(old);
                    }
                    if (val) {
                        this._setupMapMarker(val);
                    }
                    break;
                case 'icon':
                    this._setupMapMarker();
                    break;
                case 'plaeholder':
                    this._setupSuggest();
                    break;
                case 'disabled':
                    this._setupMapMarker();
                    this._setupSuggest();
                    break;
            }
        }
    }
    disconnectedCallback() {
        this._disposeMarker();
        super.disconnectedCallback();
    }
    _setupAdapters(adapter = this.adapter) {
        const gc = this._geocoder, rvgc = this._reverseGeocoder;
        // setup adapters
        if (!Utils.isNull(gc)) {
            gc.adapter = adapter;
        }
        if (!Utils.isNull(rvgc)) {
            rvgc.adapter = adapter;
        }
    }
    _setupSuggest() {
        const suggest = this._suggest;
        if (!Utils.isNull(suggest)) {
            suggest.placeholder = this.placeholder ?? 'search...';
            suggest.readonly = this.readonly;
            suggest.disabled = this.disabled;
            suggest.value = this.value;
        }
    }
    _detachMarker(map = this.map) {
        const marker = this.#marker;
        if (!Utils.isNull(marker) && marker.map === map) {
            marker.remove();
        }
    }
    _createMarker() {
        const marker = new ComponentsMaps.Maps.PacemMapMarkerElement();
        marker.addEventListener('dragend', this._dragendHandler, false);
        return marker;
    }
    _disposeMarker() {
        const marker = this.#marker;
        if (!Utils.isNull(marker)) {
            marker.removeEventListener('dragend', this._dragendHandler, false);
        }
    }
    _setupMapMarker(map = this.map) {
        const marker = this.#marker || (this.#marker = this._createMarker());
        marker.icon = this.icon;
        marker.draggable = !this.readonly && !this.disabled;
        marker.hide = this.disabled;
        const address = this.value;
        if (address && address.position) {
            marker.position = address.position;
        }
        if (marker.map !== map && !Utils.isNull(map)) {
            map.appendChild(marker);
        }
    }
    _setup() {
        this._setupAdapters();
        this._setupSuggest();
        this._setupMapMarker();
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemGeolocateElement.prototype, "adapter", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], PacemGeolocateElement.prototype, "map", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemGeolocateElement.prototype, "icon", void 0);
__decorate([
    ViewChild(P + '-data[ds]')
], PacemGeolocateElement.prototype, "_datasource", void 0);
__decorate([
    ViewChild(P + '-suggest')
], PacemGeolocateElement.prototype, "_suggest", void 0);
__decorate([
    ViewChild(P + '-map-geocode')
], PacemGeolocateElement.prototype, "_geocoder", void 0);
__decorate([
    ViewChild(P + '-map-geocode[reverse]')
], PacemGeolocateElement.prototype, "_reverseGeocoder", void 0);
PacemGeolocateElement = __decorate([
    CustomElement({
        tagName: P + '-geolocate', shadow: false, template: `<${P}-map-geocode search="{{ ::_suggest.hint }}"
    disabled="{{ (::_suggest.hint || '').length < ${MIN_LENGTH} }}" on-success="::_datasource.model = $event.detail"></${P}-map-geocode>
<${P}-map-geocode reverse on-success=":host.changeHandler($event)"></${P}-map-geocode>

<${P}-data ds></${P}-data>

<${P}-suggest on-change=":host.changeHandler($event)" datasource="{{ ::_datasource.model || [] }}"
    compare-by="fullAddress" text-property="fullAddress"></${P}-suggest>`
    })
], PacemGeolocateElement);
export { PacemGeolocateElement };
